// GoogleHotels.js
import React, { useState } from "react";
import LanguageModal from "./LanguageModal";

const GoogleHotels = () => {
  const [showModal, setShowModal] = useState(false);

  const links = {
    es: "https://www.google.com/travel/hotels/entity/CgoIwoGT39ixmbJaEAE/reviews?hl=es",
    en: "https://www.google.com/travel/hotels/entity/CgoIwoGT39ixmbJaEAE/reviews?hl=en",
    de: "https://www.google.com/travel/hotels/entity/CgoIwoGT39ixmbJaEAE/reviews?hl=de",
    fr: "https://www.google.com/travel/hotels/entity/CgoIwoGT39ixmbJaEAE/reviews?hl=fr",
    pt: "https://www.google.com/travel/hotels/entity/CgoIwoGT39ixmbJaEAE/reviews?hl=pt",
    nl: "https://www.google.com/travel/hotels/entity/CgoIwoGT39ixmbJaEAE/reviews?hl=nl",
  };

  return (
    <>
      <button className="full-width-button" onClick={() => setShowModal(true)}>
         <i className="bi bi-google icon-space" />
        Google Hotels
      </button>
      {showModal && (
        <LanguageModal
          title="Google Hotels"
          icon="bi bi-google"
          links={links}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default GoogleHotels;
